import React from 'react'
import * as a from '../'
import {CompanyFields} from '../../../_apiModels/_companyModels'

type Props = {
  formik: any
  settingName: string
  verticalLabel?: boolean
  hideLabel?: boolean
}

export const AncientInputSettingField: React.FC<Props> = ({
  settingName,
  formik,
  verticalLabel,
  hideLabel,
}) => {
  const textbox = (index: number) => {
    return (
      <>
        <input
          type='text'
          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          placeholder={
            formik.getFieldProps('companyFields[' + index + '].settingDescription').value
          }
          {...formik.getFieldProps('companyFields[' + index + '].fieldValue')}
        />
      </>
    )
  }
  const listItems =
    formik.values.companyFields && formik.values.companyFields.length > 0 ? (
      formik.values.companyFields?.map((companyField: CompanyFields, index: number) => {
        const isTheSetting =
          formik.getFieldProps('companyFields[' + index + '].settingName').value === settingName
        const label = hideLabel
          ? ''
          : formik.getFieldProps('companyFields[' + index + '].settingDescription').value
        if (isTheSetting) {
          return (
            <>
              {verticalLabel == true ? (
                <a.AncientFormWrapVertical displayText={label}>
                  {textbox(index)}
                </a.AncientFormWrapVertical>
              ) : (
                <a.AncientFormWrapHorizontal displayText={label}>
                  {textbox(index)}
                </a.AncientFormWrapHorizontal>
              )}
            </>
          )
        } else {
          return null
        }
      })
    ) : (
      <></>
    )

  return listItems
}
